import { render, staticRenderFns } from "./NavMenuItem.vue?vue&type=template&id=670b95c9&"
import script from "./NavMenuItem.vue?vue&type=script&lang=ts&"
export * from "./NavMenuItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports